var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Button from "@material-ui/core/Button";
import FTLDots from "../../../loaders/FTLDots";
import FTLButtonStyle from "../styles/FTLButtonStyle";
export default React.forwardRef((_a, ref) => {
    var { variant = "contained", color = "primary", async, children, disabled, isSelected = false } = _a, otherProps = __rest(_a, ["variant", "color", "async", "children", "disabled", "isSelected"]);
    const classes = FTLButtonStyle({ async });
    return (React.createElement(Button, Object.assign({}, otherProps, { ref: ref, variant: variant, color: color, disableRipple: true, disabled: disabled, classes: {
            root: classes.root,
            sizeLarge: classes.large,
            sizeSmall: classes.small,
            focusVisible: classes.focus,
            containedSecondary: `${classes.secondary} ${isSelected ? classes.selected : ""}`,
            textSecondary: classes.textSecondary,
            containedPrimary: classes.primary,
            text: classes.tertiary,
            disabled: classes.disabled,
            label: classes.label,
        } }),
        async && (React.createElement(FTLDots, { className: classes.dots, color: variant === "contained" && color === "primary"
                ? "light"
                : "tertiary" })),
        React.createElement("span", { className: classes.buttonContentWrapper, style: { color: async ? "transparent" : "inherit" } }, children)));
});
//# sourceMappingURL=FTLButton.js.map